<template>
  <div class="catalog-group fill-height" :key="theGroup.pageNumber">
    <v-row class="fill-height" no-gutters>
      <v-col cols="auto" class="prev-column" style="width: 75px;">
        <router-link :to="prevUrl">
          <v-btn
            v-if="prevUrl"
            class="prev-btn"
            fab
            outlined
            :disabled="!prevUrl"
            style="color: rgb(150,150,150); text-shadow: 0px 2px 0px rgba(255,255,255, .75);"
          >
            <div>
              <v-icon large>mdi-chevron-left</v-icon>
              <div>Prev</div>
            </div>
          </v-btn>
        </router-link>
      </v-col>
      <v-col class="content-column" style="overflow: hidden;">
        <v-row no-gutters class="header-row">
          <v-col cols="8" class="image-stage-column">
            <v-row no-gutters>
              <v-col cols="auto" style="width: 100px;" class="small-carousel-column">
                <div style="height: 100px;">
                  <img
                    v-if="theGroup.PromoProduct && theGroup.promoProduct.brandLogo"
                    :src="theGroup.promoProduct.brandLogo.smallUrl"
                    style="max-height: 100%; max-width: 100%; height: auto; width: auto;"
                  />
                </div>
                <hooper
                  ref="smallCarousel"
                  group="carousel-group"
                  :itemsToShow="7"
                  :itemsToSlide="1"
                  :initialSlide="0"
                  :infiniteScroll="false"
                  :vertical="true"
                  :centerMode="true"
                  :trimWhiteSpace="false"
                  style="height: 600px"
                >
                  <slide
                    v-for="(image, index) in theGroup.images"
                    :key="image.name"
                    class="small-slide"
                  >
                    <div class="carousel-container-small" @click="slideTo(index)">
                      <img class="carousel-image-small" :src="image.smallUrl" />
                    </div>
                  </slide>
                  <!--
                  <hooper-navigation slot="hooper-addons"></hooper-navigation>
                  -->
                </hooper>
              </v-col>
              <v-col style="overflow: hidden;" class="large-carousel-column">
                <hooper
                  ref="largeCarousel"
                  group="carousel-group"
                  style="height: 700px"
                  :centerMode="true"
                  :transition="0"
                  :mouseDrag="false"
                  :touchDrag="false"
                  :wheelControl="false"
                  :keysControl="false"
                >
                  <slide v-for="image in theGroup.images" :key="image.name" class="large-slide">
                    <div class="carousel-container-large">
                      <div
                        style="display: inline-flex; position: relative;"
                        @click="clickImage(image)"
                      >
                        <img
                          class="carousel-image-large"
                          :src="image.largeUrl"
                          style="overflow: hidden;"
                        />
                        <v-icon
                          color="white"
                          style="position: absolute; top: 5px; right: 5px; background-color: darkslategray; padding: 5px; opacity: 0.5;"
                        >mdi-arrow-expand-all</v-icon>
                      </div>
                    </div>
                  </slide>
                </hooper>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" class="group-header-column">
            <div class="group-header" style="margin-bottom: 50px;">
              <h1>{{theGroup.title}}</h1>
              <v-divider v-if="theGroup.romance" class="my-3"></v-divider>
              <p>{{theGroup.romance}}</p>
              <v-divider v-if="theGroup.features.length > 0" class="my-3"></v-divider>
              <ul>
                <li v-for="feature in theGroup.features" :key="feature">{{feature}}</li>
              </ul>
            </div>

            <promo-product
              v-if="theGroup.showPromoProduct && theGroup.promoProduct"
              :product="theGroup.promoProduct"
              :group="theGroup"
              width="100%"
            ></promo-product>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="pa-3">
            <div id="product-table-container">
              <table id="product-table" style="padding: 0px 5px;">
                <thead>
                  <tr>
                    <th class="picture-column"></th>
                    <th class="id-column"></th>
                    <th
                      v-for="(column, index) in frontColumns"
                      :key="column.id"
                      :class="{ 'price-column': column.IsPrice, 'last-front-column': index == frontColumns.length - 1 }"
                    >{{column.name}}</th>
                    <th class="more-column"></th>
                    <th class="add-to-cart-column"></th>
                  </tr>
                </thead>
                <tbody>
                  <product-row
                    v-for="product in theGroup.products"
                    :key="product.sku"
                    :product="product"
                    :group="theGroup"
                    :frontColumns="frontColumns"
                  ></product-row>
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto" class="next-column" style="width: 75px;">
        <router-link :to="nextUrl">
          <v-btn
            v-if="nextUrl"
            class="next-btn"
            fab
            outlined
            :disabled="!nextUrl"
            style="color: rgb(150,150,150); text-shadow: 0px 2px 0px rgba(255,255,255, .75);"
          >
            <div>
              <v-icon large>mdi-chevron-right</v-icon>
              <div>Next</div>
            </div>
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ProductRow from "../components/ProductRow.vue";
import PromoProduct from "../components/PromoProduct.vue";
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";

export default {
  components: {
    ProductRow,
    PromoProduct,
    Hooper,
    Slide,
    HooperNavigation
  },
  data: () => ({
    theCarouselItem: 0
  }),
  methods: {
    clickImage: function(image) {
      this.$store.commit("zoomImage", image);
    },
    slideTo: function(index) {
      this.$refs.smallCarousel.slideTo(index);
    },
    swap: function() {
      this.things = ["four"];
    },
    addPromoToCart: function() {
      this.$store.dispatch("addToCart", {
        product: this.theGroup.promoProduct,
        quantity: 1
      });
    }
  },
  computed: {
    dealer: function() {
      return this.$store.state.dealer;
    },
    prevUrl: function() {
      var currentIndex = this.$store.getters.filteredGroups.findIndex(
        group => group.pageNumber == this.$route.params.pageNumber
      );
      var prevIndex = currentIndex - 1;
      var prevGroup =
        prevIndex < 0 ? null : this.$store.getters.filteredGroups[prevIndex];
      return !prevGroup
        ? ""
        : `/Manufacturers/${this.$route.params.manufacturerId}/Avenue/Groups/${prevGroup.pageNumber}`;
    },
    nextUrl: function() {
      var currentIndex = this.$store.getters.filteredGroups.findIndex(
        group => group.pageNumber == this.$route.params.pageNumber
      );
      var nextIndex = currentIndex + 1;
      var nextGroup =
        nextIndex >= this.$store.getters.filteredGroups.length
          ? null
          : this.$store.getters.filteredGroups[nextIndex];

      return !nextGroup
        ? ""
        : `/Manufacturers/${this.$route.params.manufacturerId}/Avenue/Groups/${nextGroup.pageNumber}`;
    },
    config: function() {
      return this.$store.state.config;
    },
    frontColumns: function() {
      return this.config.frontColumns.filter(column =>
        this.theGroup.products.some(product => product.cells[column.id].display)
      );
    },
    theGroup: function() {
      return this.$store.getters.filteredGroups.find(
        group => group.pageNumber == this.$route.params.pageNumber
      );
    },
    thePricelist: function() {
      return this.$store.getters.thePricelist;
    }
  }
};
</script>

<style lang="scss">
.hooper-track {
  padding-left: 0px !important; //To prevent vuetify from adding padding
}
</style>

<style lang="scss" scoped>
.small-carousel-column {
}

.large-carousel-column {
  //padding: 0px 10px;
}
.small-slide {
  cursor: pointer;
  opacity: 0.5;

  &.is-current {
    opacity: 1;
    transform: scale(1.1);
    //border: 1px solid gray;

    .carousel-image-small {
      box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.5);
      //border: 1px solid black;
    }
  }
}

.carousel-thumbnails {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.carousel-container-small {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  .carousel-image-small {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
}

.carousel-container-large {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  padding: 0px 20px;

  .carousel-image-large {
    max-width: 100%;
    max-height: 650px;
    width: auto;
    height: auto;
    box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.15);
  }
}

.carousel-thumbnail-column {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  max-height: 700px;
  overflow: auto;
}

.products {
  display: flex;
  flex-wrap: wrap;

  .product {
    margin: 10px;
  }
}

.header-row {
  min-height: 700px;
}

.catalog-group {
  width: 100%;
}

.prev-column {
  //background-color: white;
  display: flex;
  justify-content: center;
  text-shadow: rgba(245, 245, 245, 0.5) 3px 5px 1px;
}

.content-column {
  padding-top: 15px;
}

.next-column {
  //background-color: white;
}

.prev-btn {
  position: fixed;
  top: 50%;
  left: 10px;
}

.next-btn {
  position: fixed;
  top: 50%;
  right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>

<style lang="scss">
//Shop3/PageDetails.scss
$amp-lighter: rgb(230, 230, 230);

#product-table-container {
  width: 100%;
  overflow: auto;

  #product-table {
    border-collapse: separate;
    border-spacing: 0px 10px;
    width: 100%;
    font-size: 12px;
    //table-layout: fixed;

    thead {
      border: none;

      tr {
        border: none;

        th {
          border: none;
          vertical-align: top;
          padding: 0px 10px;
          text-align: left;
          //min-width: 200px;
          //width: 200px;
          //max-width: 200px;

          &.picture-column {
            width: 1px;
          }
          &.last-front-column {
            //width: 100%;
          }

          &.more-column {
            width: 1px;
          }

          &.add-to-cart-column {
            width: 1px;
          }
        }

        /*
        th {
          border: none;
          vertical-align: top;
          padding: 0px 10px;
          text-align: left;
          min-width: 200px;
          width: 200px;
          max-width: 200px;

          &.picture-column {
            min-width: 100px;
            width: 100px;
            max-width: 100px;
          }

          &.id-column {
            min-width: 100px;
            width: 100px;
            max-width: 100px;
          }

          &.description-column {
            min-width: 200px;
            width: 200px;
            max-width: 200px;
          }

          &.price-column {
            width: auto;
          }

          &.more-column {
            min-width: 110px;
            width: 110px;
            max-width: 110px;
          }

          &.add-to-cart-column {
            min-width: 200px;
            width: 400px;
            max-width: 400px;
          }
        }
        */
      }
    }

    tbody {
      tr {
        //outline: 2px solid black;
        background-color: white;

        .product-image-container {
          width: 100px;
          height: 50px;
          display: flex;
          justify-content: center;
          padding-left: 10px;

          .product-image {
            max-height: 100%;
            max-width: 100%;
            width: auto;
            height: auto;
          }
        }

        &:nth-child(even) {
          background-color: rgb(250, 250, 250);
        }

        td {
          padding: 10px;

          .cell-container {
            height: 50px;
            overflow-y: hidden;
          }

          &.more-cell {
            //border-left: 2px solid black;
            //border-right: 2px solid black;
          }

          &.add-to-cart-cell {
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>